import React from 'react';
import { Grid, Typography, CircularProgress } from '@material-ui/core';
import CloudUploadRounded from '@material-ui/icons/CloudUploadRounded';

export const VideoUploadButton = ({ 
    onUpload, 
    isProcessing,
    uploadMouseHover,
    onMouseEnter,
    onMouseLeave,
    inputKey
}) => {
    if (isProcessing) {
        return <CircularProgress />;
    }

    return (
        <Grid item style={{ marginTop: "10px", marginBottom: "10px", width: 150 }}>
            <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <label htmlFor="videoUpload">
                    <input 
                        name="" 
                        onChange={(event) => onUpload(event.target.files[0])} 
                        accept=".mp4" 
                        key={inputKey}
                        type="file" 
                        id="videoUpload" 
                        hidden 
                    />
                    <Grid style={{ 
                        borderRadius: '5px', 
                        padding: 10, 
                        paddingTop: 15, 
                        backgroundColor: uploadMouseHover ? "#141e8c" : "#3f51b5" 
                    }} 
                    container 
                    direction="row"
                    >
                        <Grid item>
                            <CloudUploadRounded style={{ color: "white" }} />
                        </Grid>
                        <Grid item>
                            <Typography style={{ marginLeft: 5, color: "white" }}>
                                Upload video
                            </Typography>
                        </Grid>
                    </Grid>
                </label>
            </div>
        </Grid>
    );
};